import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { getCopy } from 'utils/copy';
import { joinClasses, isObject } from 'utils/utils';
import formatPrice from 'utils/formatPrice';
import s from 'components/shared/theaters/ticketing/ticketTypes/ticketTypes.sss';


export default class TicketType extends Component {

	constructor(props) {
		super(props);

		this.removeTicket = this.removeTicket.bind(this);
		this.addTicket = this.addTicket.bind(this);

		this.touchStartAdd = 0;
		this.touchStartRemove = 0;

		this.updateQuantity(props);
	}

	componentWillReceiveProps(props) {
		this.updateQuantity(props);
	}

	updateQuantity({ ticketing, type }) {
		if (ticketing.tickets && isObject(ticketing.tickets)) {
			const ticket = ticketing.tickets[type.id];
			this.quantity = (ticket && ticket.quantity) || 0;
		} else {
			this.quantity = 0;
		}
	}

	addTicket(event) {
		if (this.props.hasMaxTickets) return;

		if (event.type === 'touchstart') {
			this.touchStartAdd++;
			event.preventDefault();
		} else if (event.type === 'click') {
			if (this.touchStartAdd > 0) {
				this.touchStartAdd = Math.max(this.touchStartAdd - 1, 0);
				return;
			}
		}
		// Update the quantity in the store with one more ticket
		Store.emit(actions.UPDATE_TICKET_TYPE_QUANTITY, {
			ticketTypeId: this.props.type.id,
			quantity: this.quantity + 1
		});
	}

	removeTicket(event) {
		if (event.type === 'touchstart') {
			this.touchStartRemove++;
			event.preventDefault();
		} else if (event.type === 'click') {
			if (this.touchStartRemove > 0) {
				this.touchStartRemove = Math.max(this.touchStartRemove - 1, 0);
				return;
			}
		}
		// Update the quantity in the store with one less ticket
		Store.emit(actions.UPDATE_TICKET_TYPE_QUANTITY, {
			ticketTypeId: this.props.type.id,
			quantity: this.quantity >= 1 ? this.quantity - 1 : this.quantity
		});
	}

	render(props) {
		const {
			type, // Object
			hasMaxTickets,
			currencyCopy = 'CURRENCY'
		} = props;

		const price = this.quantity > 0 ? this.quantity * type.price : type.price;
		const total = getCopy(currencyCopy, { value: formatPrice(price) });

		return (
			<div class={s.type}>
				<button class={joinClasses(s.press, this.quantity < 1 && s.pressHide)} onClick={this.removeTicket} onTouchStart={this.removeTicket}>-</button>
				<div class={s.typeDescription}>
					<div class={s.typeName}>{this.quantity} {type.description}</div>
					<div class={s.typePrice}>
						{getCopy(currencyCopy, { value: formatPrice(type.price) })} {!!this.quantity && `(${total})`}
					</div>
				</div>
				<button class={joinClasses(s.press, hasMaxTickets && s.pressHide)} onClick={this.addTicket} onTouchStart={this.addTicket}>+</button>
			</div>
		);
	}

}
